import { useEffect } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Image from 'next/image'
import {
    Typography,
    Button,
    Title,
    Section,
    FeatureCard,
    PartnerLogo,
    Divider,
    Accordion
} from '../features/base-ui'
import { BrokerCard } from '../features/webpage'
import { MediaQuery } from '../features/base-ui/Utility'
import { useDataProvider } from '../hooks/dataProvider'
import { useBreakpoints } from '../hooks'

// import DateView from '../panel/lib/components/DateView'
import { css, useTheme } from '@emotion/react'
import { Layout } from '../features/layouts/Layout'
import { getBrokers, getPageData } from '../lib'
// import { useDataProvider } from '../hooks/dataProvider'
import { createServerApolloClient } from '../dsl/client'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import LoginBox from '../features/webpage/LoginBox'
import EditorTypography from '../features/webpage/EditorTypography'
// import { text } from 'micro'

function Homepage({ pageData, footerData, contactData, brokers }) {
    const theme = useTheme()
    const breakpoint = useBreakpoints()
    const { t } = useTranslation()
    const { setData } = useDataProvider()
    const sections = pageData?.sections
    useEffect(
        () => {
            setData({ homeNav: true, footerData, contactData })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    )
    const router = useRouter()

    return (
        <main>
            <section>
                <div
                    css={css`
                        background-image: url('/img/home/hero/moment-discussion-1.jpg');
                        background-size: cover;
                        height: ${breakpoint.xl ? '36rem' : '45rem'};
                        display: flex;
                        align-items: center;
                    `}
                >
                    <div className="flex items-center justify-center lg:ml-60 2xl:mt-24 xl:pl-32 xl:pt-20 px-4 lg:px-2 xl:px-0 md:container mx-auto">
                        <div
                            css={css`
                                ${MediaQuery('lg', 'max')} {
                                    order: 1;
                                } ;
                            `}
                        >
                            <Typography
                                type="h1"
                                color="secondary"
                                style={`${MediaQuery(
                                    'md',
                                    'max'
                                )} {text-align: center;} text-shadow: 1px 1px 2px ${theme.colors.lighterGray
                                    }; `}
                            >
                                {sections?.[0]?.title}
                            </Typography>
                            <EditorTypography
                                type="h3"
                                color="secondary"
                                className="pt-6"
                                style={`${MediaQuery(
                                    'md',
                                    'max'
                                )} {text-align: center;} text-shadow: 1px 1px 2px ${theme.colors.lighterGray
                                    };`}
                            >
                                <div
                                    className="dynamic-content"
                                    dangerouslySetInnerHTML={{
                                        __html: sections?.[0]?.content
                                    }}
                                />
                            </EditorTypography>
                            <div className="flex flex-wrap justify-center">
                                <Button
                                    backgroundColor="secondary"
                                    color="lighterGray"
                                    className="mt-10 ml-6"
                                    style="padding: 0.5rem 1.5rem; box-shadow: none; border:1px solid #0000007a;"
                                    onClick={() => {
                                        router.push('/about')
                                    }}
                                >
                                    {t('how does it work?')}
                                </Button>
                                <Button
                                    backgroundColor="primary"
                                    color="secondary"
                                    className="mt-10 ml-6"
                                    style="padding: 0.5rem 1.5rem; box-shadow: none; border:1px solid #0000007a;"
                                    onClick={() => {
                                        router.push('/about')
                                    }}
                                >
                                    {t('what is rebate?')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Section
                backgroundImage="/img/svg/Background-mountain.svg"
                style="background-position: bottom;"
            >
                <div className="grid lg:grid-cols-2 content-center">
                    <div className="order-2 lg:order-2 mt-20 lg:mt-0">
                        <Title
                            color="text"
                            highlight="فارکس ریبیت"
                            imgSrc="/img/svg/title-line.svg"
                            style={`${MediaQuery(
                                'md',
                                'max'
                            )} {justify-content: center; .typography{text-align: center;};}`}
                        >
                            {sections?.[1]?.title}
                        </Title>
                        <EditorTypography
                            type="p"
                            className="pt-6"
                            lineHeight="2rem"
                            style={`${MediaQuery(
                                'md',
                                'max'
                            )} {text-align: center;}`}
                        >
                            <div
                                className="dynamic-content"
                                dangerouslySetInnerHTML={{
                                    __html: sections?.[1]?.content
                                }}
                            />
                        </EditorTypography>
                        {/* <Image
                            alt="chart svg"
                            src="/img/home/who-we-are/forex.svg"
                            width={400}
                            height={300}
                        /> */}
                    </div>
                    <div
                        className="order-1 lg:order-2 pb-10 w-full md:w-96"
                        /* eslint-disable indent */
                        css={css`
                            border-radius: ${theme.borderRadius.default};
                            height: fit-content;
                            width: ${(breakpoint.lg && '25rem') ||
                            (breakpoint.xl2 && '30rem')};
                            background-color: ${theme.colors.mainBackground};
                            justify-self: center;
                            margin-top: -8rem;
                            box-shadow: ${theme.boxShadow.md};
                        `}
                    >
                        <LoginBox />
                    </div>
                </div>
            </Section>
            <Section
                backgroundImage="/img/home/how/home-how-background.jpg"
                parallax={true}
            >
                <div className="grid lg:grid-cols-2 content-center">
                    <div>
                        <Title
                            color="lighterGray"
                            highlight="چه طور"
                            imgSrc="/img/svg/title-line.svg"
                            style={`${MediaQuery(
                                'md',
                                'max'
                            )} {justify-content: center; .typography{text-align: center;};}`}
                        >
                            {sections?.[2]?.title}
                        </Title>
                        <EditorTypography
                            type="p"
                            color="lighterGray"
                            className="pt-6"
                            style={`${MediaQuery(
                                'md',
                                'max'
                            )} {text-align: center;}`}
                        >
                            <div
                                className="dynamic-content"
                                dangerouslySetInnerHTML={{
                                    __html: sections?.[2]?.content
                                }}
                            />
                        </EditorTypography>
                        <Button
                            backgroundColor="primary"
                            color="secondary"
                            className="mt-4 lg:mr-0 mx-auto"
                            onClick={() => {
                                router.push('/about#how-does-forexrebate-work')
                            }}
                        >
                            {t('more info')}
                        </Button>
                    </div>
                    <div className="self-center justify-self-center">
                        <Image
                            alt="chart svg"
                            src="/img/home/how/Payment-TRANSPARRENT.png"
                            width="400"
                            height="400"
                        />
                    </div>
                </div>
            </Section>
            <Section backgroundImage="/img/home/start/bg-rate.svg">
                <Title
                    color="text"
                    highlight="شروع کنید"
                    imgSrc="/img/svg/title-line.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {sections?.[3]?.title}
                </Title>
                <div className="grid lg:grid-cols-3 justify-items-center content-center py-10">
                    <div className="flex flex-col">
                        <Image
                            alt="chart svg"
                            src="/img/home/start/steps_1.svg"
                            width={200}
                            height={200}
                        />
                        <div className="flex items-center pt-6">
                            <Image
                                alt="chart svg"
                                src="/img/home/start/Number-One.svg"
                                width={50}
                                height={50}
                            />
                            <EditorTypography
                                type="h4"
                                color="secondary"
                                fontWeight="Bold"
                                className="px-2"
                            >
                                {sections?.[4]?.content}
                            </EditorTypography>
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <Image
                            alt="chart svg"
                            src="/img/home/start/steps_2.svg"
                            width={200}
                            height={200}
                        />
                        <div className="flex items-center pt-6">
                            <Image
                                alt="chart svg"
                                src="/img/home/start/Number-Two.svg"
                                width={50}
                                height={50}
                            />
                            <EditorTypography
                                type="h4"
                                color="secondary"
                                fontWeight="Bold"
                                className="px-2"
                            >
                                {sections?.[5]?.content}
                            </EditorTypography>
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <Image
                            alt="chart svg"
                            src="/img/home/start/steps_3.svg"
                            width={200}
                            height={200}
                        />
                        <div className="flex items-center pt-6">
                            <Image
                                alt="chart svg"
                                src="/img/home/start/Number-Three.svg"
                                width={50}
                                height={50}
                            />
                            <EditorTypography
                                type="h4"
                                color="secondary"
                                fontWeight="Bold"
                                className="px-2"
                            >
                                {sections?.[6]?.content}
                            </EditorTypography>
                        </div>
                    </div>
                </div>
                <Button
                    backgroundColor="secondary"
                    color="lighterGray"
                    className="mt-10 mx-auto"
                    onClick={() => {
                        router.push('/auth/signin')
                    }}
                >
                    {t('begin')}
                </Button>
            </Section>
            <Section
                backgroundImage="/img/home/tradingview/home-chart-background.jpg"
                parallax={true}
            >
                <Title
                    color="medGray"
                    highlightColor="secondary"
                    highlight="نمودار"
                    imgSrc="/img/svg/title-line-secondary.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {sections?.[7]?.title}
                </Title>
                <div className="grid lg:grid-cols-2 content-center pt-6">
                    <div className="self-center justify-self-center">
                        <Link href="/charts">
                            <span className="cursor-pointer">
                                <Image
                                    alt="chart svg"
                                    src="/img/home/tradingview/presentation.png"
                                    width="600"
                                    height="400"
                                />
                            </span>
                        </Link>
                    </div>
                    <div className="self-center justify-self-center">
                        <EditorTypography
                            type="div"
                            color="text"
                            className="pt-10"
                            style={`${MediaQuery(
                                'md',
                                'max'
                            )} {text-align: center;}`}
                        >
                            <div
                                className="dynamic-content"
                                dangerouslySetInnerHTML={{
                                    __html: sections?.[7]?.content
                                }}
                            />
                        </EditorTypography>
                        <Button
                            backgroundColor="secondary"
                            color="lighterGray"
                            className="mt-10 lg:mr-0 mx-auto w-40"
                            onClick={() => {
                                router.push('/charts')
                            }}
                        >
                            {t('charts')}
                        </Button>
                    </div>
                </div>
            </Section>
            <Section backgroundImage="/img/svg/Background-mountain.svg">
                <Title
                    color="text"
                    highlight="چرا"
                    imgSrc="/img/svg/title-line.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {sections?.[8]?.title}
                </Title>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 justify-items-center py-16 gap-6">
                    <FeatureCard
                        title={sections?.[9]?.title}
                        description={sections?.[9]?.content}
                        iconSrc="/img/home/why-choose-us/interest-rate.svg"
                    />
                    <FeatureCard
                        title={sections?.[10]?.title}
                        description={sections?.[10]?.content}
                        iconSrc="/img/home/why-choose-us/24-support.svg"
                    />
                    <FeatureCard
                        title={sections?.[11]?.title}
                        description={sections?.[11]?.content}
                        iconSrc="/img/home/why-choose-us/forex-icon.svg"
                    />
                    <FeatureCard
                        title={sections?.[12]?.title}
                        description={sections?.[12]?.content}
                        iconSrc="/img/home/why-choose-us/wallet.svg"
                    />
                </div>
            </Section>
            <Section backgroundColor="primary">
                <Title
                    color="medGray"
                    highlightColor="secondary"
                    highlight="پرداخت"
                    imgSrc="/img/svg/title-line-secondary.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {sections?.[13]?.title}
                </Title>
                <div className="grid lg:grid-cols-2">
                    <EditorTypography
                        type="p"
                        color="text"
                        className="pt-10 lg:max-w-sm 2xl:mr-24"
                        style={`${MediaQuery(
                            'md',
                            'max'
                        )} {text-align: center; margin-bottom: 2rem;}`}
                    >
                        <div
                            className="dynamic-content"
                            dangerouslySetInnerHTML={{
                                __html: sections?.[13]?.content
                            }}
                        />
                    </EditorTypography>
                    <div className="flex justify-evenly">
                        <PartnerLogo
                            imageSrc="/img/home/pay/paypal.svg"
                            caption="paypal"
                        />
                        <PartnerLogo
                            imageSrc="/img/home/pay/tether-usdt-logo.svg"
                            caption="tether"
                        />
                    </div>
                </div>
            </Section>
            <Section backgroundImage="/img/home/brokers/our-brokers-background.png">
                <Title
                    color="text"
                    highlight={t('brokers')}
                    imgSrc="/img/svg/title-line.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {t('list of brokers')}
                </Title>
                <div className="grid lg:grid-cols-2 py-16 gap-4 xl:gap-10">
                    {brokers?.map((b) => (
                        <BrokerCard key={b.id} broker={b} />
                    ))}
                </div>
                <Button
                    backgroundColor="primary"
                    color="secondary"
                    className="w-40 mx-auto"
                    onClick={() => {
                        router.push('/brokers')
                    }}
                >
                    {t('all brokers')}
                </Button>
            </Section>
            <Section
                backgroundImage="/img/home/faq/home-faq-background.jpg"
                parallax={true}
            >
                <Title
                    color="lighterGray"
                    highlight="پرسش های"
                    imgSrc="/img/svg/title-line.svg"
                    style={`${MediaQuery(
                        'md',
                        'max'
                    )} {justify-content: center; .typography{text-align: center;};}`}
                >
                    {sections?.[14]?.title}
                </Title>
                <div className="grid justify-items-start pt-10 xl:gap-10"
                // css={css`
                //     .accordion-content {
                //         ${['ar', 'fa'].indexOf(router.locale) !== -1 ? 'padding-right: 4rem' : 'padding-left: 4rem'};
                //     }
                // `}
                >
                    {sections
                        ?.slice(15)
                        .filter((s) => s?.content)
                        .map((s, i) => (
                            <div className="flex w-full mt-6 lg:mt-0" key={i}>
                                <div className="pr-6 w-full">
                                    <Accordion
                                        title={
                                            <div className="flex items-center">
                                                <Image
                                                    alt=""
                                                    src="/img/svg/check.svg"
                                                    width={38}
                                                    height={38}

                                                />
                                                <Typography type="h4" color="lighterGray" style="margin: 0 10px;">
                                                    {s?.title}
                                                </Typography>
                                            </div>}

                                        content={
                                            <EditorTypography
                                                type="p"
                                                color="lightGray"
                                                className="pt-2 xl:px-14"
                                                align="justify"
                                            >
                                                {s?.content}
                                            </EditorTypography>
                                        }
                                    />


                                </div>
                            </div>
                        ))}
                </div>
            </Section>
            <Divider width="100%" spacer="none" depth="5px" withGradient />
        </main>
    )
}

Homepage.Layout = Layout

export default Homepage

export async function getStaticProps({ locale }) {
    const client = createServerApolloClient()

    const pageData = await getPageData(
        'c840b031-0754-44d2-8c21-1510be49b62c',
        locale,
        client
    )
    const footerData = await getPageData(
        'b13aea62-c45c-4b49-9f41-8dc67d48753b',
        locale,
        client
    )
    const contactData = await getPageData(
        'c848a31b-b22d-4708-9c4a-63ea0cf878c3',
        locale,
        client
    )
    const brokers = await getBrokers(4, locale, client)

    return {
        props: {
            pageData,
            footerData,
            contactData,
            brokers,
            ...(await serverSideTranslations(locale, ['common']))
        },
        revalidate: 60
    }
}
